export enum BusStopType {
  PickUp,
  DropOFF,
}
